import React from 'react';
import { Route, Link, Switch } from "react-router-dom";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import {Tabs, Tab} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import StudioClasses from './programs/StudioClasses';
import Shows from './programs/Shows';
import Competitions from './programs/Competitions';
import Examinations from './programs/Examinations';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 30
  }
}));

export default function Programs(props) {

  const { match } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div className={classes.root}>
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="center"
      >
        <Grid item xs={12} sm={8}>
          <Tabs variant={isMobile ? "scrollable" : "fullWidth"} value={match.params.subroute}>
            <Tab label="Studio Classess"
              value="studio-classes"
              component={Link}
              to="/programs/studio-classes"
            />

            <Tab label="Shows"
              value="shows"
              component={Link}
              to="/programs/shows"
            />

            <Tab label="Competitions"
              value="competitions"
              component={Link}
              to="/programs/competitions"
            />

            <Tab label="Examinations"
              value="examinations"
              component={Link}
              to="/programs/examinations"
            />

          </Tabs>
          <Switch>
            <Route exact path="/programs/studio-classes" component={StudioClasses} />
            <Route exact path="/programs/shows" component={Shows} />
            <Route exact path="/programs/competitions" component={Competitions} />
            <Route exact path="/programs/examinations" component={Examinations} />
          </Switch>

        </Grid>
      </Grid>
    </div>
  )
}

